var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg67(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2460_2755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.8906 36.8945C42.3633 27.7148 30.8203 23.5352 29.707 23.1055C29.668 23.0859 29.668 23.0469 29.6875 22.9883L41.6016 11.0352V9.74609C41.6016 9.55078 41.4258 9.35547 41.2109 9.35547H19.2578V0L11.1719 1.69922V2.91016H11.6211C11.6211 2.91016 13.6133 2.91016 13.6133 4.90234V9.35547H7.32422C7.20703 9.35547 7.08984 9.47266 7.08984 9.58984V12.4023H13.6133V27.7344C13.6133 32.5391 16.6992 35.8789 22.1094 35.4297C23.2617 35.332 24.3164 34.8828 25.2148 34.2969C25.625 34.0234 25.8594 33.5938 25.8594 33.1055V31.6016C24.1016 32.7734 22.6172 32.7148 22.6172 32.7148C19.1797 32.7148 19.2578 28.3594 19.2578 28.3594V12.3828H35.0586L23.6914 23.8477C23.6719 25.3516 23.6523 26.5234 23.6523 26.5625C23.6523 26.6016 23.6719 26.6211 23.7109 26.6211C34.1406 28.3789 36.9531 35.1172 36.9531 37.0898C36.9531 37.0898 38.0859 46.6406 28.5352 47.2852C28.5352 47.2852 22.2852 47.5586 21.1719 45.0586C21.1328 44.9609 21.1719 44.8828 21.2695 44.8242C22.3047 44.3555 23.0078 43.418 23.0078 42.1875C23.0078 40.332 21.875 38.8281 19.5117 38.8281C17.5977 38.8281 16.0156 40.332 16.0156 42.1875C16.0156 42.1875 15.1172 50.2148 28.5156 50C43.8281 49.7266 42.8906 36.8945 42.8906 36.8945Z",
    fill: "#0D61FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2460_2755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg67);
export default __webpack_public_path__ + "static/media/67.0b4986fef45f5d2593ae04bdc7cf1e0e.svg";
export { ForwardRef as ReactComponent };